import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/views/login/index'
import Layout from '@/views/layout/Layout'

const _import = require('./_import_' + process.env.NODE_ENV)


Vue.use(Router)

export const constantRouterMap = [
    {
        path: '/login',
        name: 'Login',
        component:Login,
        hidden: true,
    },
  {
      path: '/test-result/:Id(\\d+)',
      name: '测评结果',
      component: _import('form-conf/AssessmentDetail'),
      hidden: true,
    },
    {
        path: '',
        component: Layout,
        redirect: '/activity',
        icon: 'icon-yibiaopan',
        noDropdown: true,
        children: [{ path: 'dashboard', component: _import('dashboard/Dashboard'), name: '仪表板', hidden: true }]
    },
]

export default new Router({
    // mode: 'history', //后端支持可开
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
})


export const asyncRouterMap = [
    {
        path: "/User",
        name: "用户",
        component: Layout,
        redirect: '/User/UserList',
        icon: 'icon-yonghu1',
        children: [
            { path: "UserList", component: _import('user/UserList'), name: "用户列表", icon: 'icon-liebiao', meta: { role: ['UserView'] }, },
            { path: "AddUser", component: _import('user/AddUser'), name: "添加新用户", hidden: true, meta: { role: ['AddUser'] } },
            { path: "EditUser/:Id(\\d+)", component: _import('user/AddUser'), name: "编辑用户", hidden: true, meta: { role: ['EditUser'] } },
            { path: "RoleList", component: _import('user/RoleList'), name: "角色列表", icon: 'icon-jiaoseguanli', meta: { role: ['RoleView'] } },
            { path: "AddRole", component: _import('user/AddRole'), name: "添加新角色", hidden: true, meta: { role: ['AddRole'] } },
            { path: "EditRole/:Id(\\d+)", component: _import('user/AddRole'), name: "编辑角色", hidden: true, meta: { role: ['EditRole'] } },
            { path: "PermissionList", component: _import('user/PermissionList'), name: "权限列表", icon: 'icon-quanxian', meta: { role: ['PermissionView'] } },
            { path: "AddPermission", component: _import('user/AddPermission'), name: "添加新权限", hidden: true, meta: { role: ['AddPermission'] } },
            { path: "EditPermission/:Id(\\d+)", component: _import('user/AddPermission'), name: "编辑权限", hidden: true, meta: { role: ['EditPermission'] } },
            { path: "SetRolePermission/:Id(\\d+)", component: _import('user/SetRolePermission'), name: "设置角色权限", hidden: true, meta: { role: ['SetRolePermission'] } },
            { path: "UserInfo", component: _import('user/UserInfo'), name: "个人信息", hidden: true },
	        { path: "LogList", component: _import('user/LogList'), name: "系统日志", icon: 'el-icon-tickets', meta: { role: ['LogList'] } },
            { path: "CustomerList", component: _import('customer/CustomerList'), name: "微信用户", icon: 'el-icon-tickets', meta: { role: ['WxUserView'] } },
            { path: "my-sign-list", component: _import('customer/my-sign-list'), name: "参加的活动/赛事", icon: 'el-icon-tickets', hidden: true, meta: { role: ['MySignList'] } },
        ]
    },
    //首页轮播
    {
        path: "/Banner",
        name: "轮播",
        component: Layout,
        redirect: '/banner/BannerList',
        icon: 'el-icon-picture-outline',
        children: [
            { path: "BannerList", component: _import('banner/BannerList'), name: "首页轮播", icon: 'el-icon-picture-outline', meta: { role: ['BannerView'] }, },
        ]
    },
    {
        path: "/question",
        name: "问卷管理",
        component: Layout,
        redirect: '/question/formconf',
        icon: 'el-icon-tickets',
        children: [
            //{ path: "ShootList", component: _import('shoots/ShootList'), name: "作品列表", icon: 'icon-liebiao', meta: { role: ['ShootView'] }, },
            { path: "formconf", component: _import('question/formconf'), name: "问卷维护", hidden: true, meta: { role: ['FormConf'] } },
            // { path: "ViewPoint/:Id(\\d+)", component: _import('viewpoints/ViewPoint'), name: "查看打卡", hidden: true, meta: { role: ['ViewPointView'] } },
            // { path: "PlaceList", component: _import('viewpoints/PlaceList'), name: "景点列表", icon: 'icon-liebiao', meta: { role: ['PlaceList'] } },
            // { path: "AddPlace", component: _import('viewpoints/AddPlace'), name: "添加景点", hidden: true, meta: { role: ['AddPlace'] } },
            // { path: "EditPlace/:Id(\\d+)", component: _import('viewpoints/AddPlace'), name: "编辑景点", hidden: true, meta: { role: ['EditPlace'] } },
            // { path: "OrderList", component: _import('orders/OrderList'), name: "发货列表", icon: 'icon-liebiao', meta: { role: ['OrderList'] } },
            // { path: "Verify", component: _import('viewpoints/verify'), name: "审核打卡", hidden: true, meta: { role: [] } }
        ]
    },

    {
      path: "/activity",
      name: "活动管理",
      component: Layout,
      redirect: '/activity/activity-list',
      icon: 'el-icon-tickets',
      children: [
        { path: "activity-list", component: _import('activity/activity-list'), name: "活动列表", icon: 'icon-liebiao', meta: { role: ['ActivityList'] }, },
        { path: "AddActivity", component: _import('activity/AddActivity'), name: "添加活动", hidden: true, meta: { role: ['AddActivity'] } },
        { path: "EditActivity/:Id(\\d+)", component: _import('activity/AddActivity'), name: "编辑活动", hidden: true, meta: { role: ['EditActivity'] } },
        { path: "signup-activity-list", component: _import('activity/signup-activity-list'), name: "报名列表", icon: 'icon-liebiao', meta: { role: ['SignupActivityList'] }, },
        { path: "sign-in-list", component: _import('form-conf/sign-in-list'), name: "签到列表", hidden: true, icon: 'icon-liebiao', meta: { role: ['SignInList'] } },
        { path: "pleased-list", component: _import('form-conf/pleased-list'), name: "满意度列表", hidden: true, icon: 'icon-liebiao', meta: { role: ['Pleasedlist'] } },
      ]
    },
    {
      path: "/match",
      name: "赛事管理",
      component: Layout,
      redirect: '/match/match-list',
      icon: 'el-icon-tickets',
      children: [
        { path: "match-list", component: _import('match/match-list'), name: "赛事列表", icon: 'icon-liebiao', meta: { role: ['MatchList'] }, },
        { path: "AddMatch", component: _import('match/AddMatch'), name: "添加赛事", hidden: true, meta: { role: ['AddMatch'] } },
        { path: "EditMatch/:Id(\\d+)", component: _import('match/AddMatch'), name: "编辑赛事", hidden: true, meta: { role: ['EditMatch'] } },
        { path: "signup-match-list", component: _import('match/signup-match-list'), name: "报名列表", icon: 'icon-liebiao', meta: { role: ['SignupMatchList'] }, },
        { path: "signup-match-detail/:Id(\\d+)", component: _import('match/signup-match-detail'), hidden: true, name: "赛事报名详情", icon: 'icon-liebiao', meta: { role: ['SignupMatchDetail'] }, },
        { path: "signup-match-edit/:Id(\\d+)", component: _import('match/signup-match-edit'), hidden: true, name: "赛事报名编辑", icon: 'icon-liebiao', meta: { role: ['SignupMatchEdit'] }, },
        { path: "relate-activity/:Id(\\d+)", component: _import('match/relate-activity'), hidden: true, name: "关联活动", icon: 'icon-liebiao', meta: { role: ['RelateActivity'] }, },
        { path: "score-list", component: _import('match/score-list'), name: "得分列表", icon: 'icon-liebiao', meta: { role: ['ScoreList'] }, },
      ]
    },
    {
      path: "/form",
      name: "问卷管理",
      component: Layout,
      redirect: '/form/form-conf-list',
      icon: 'el-icon-tickets',
      children: [
        { path: "form-conf-list", component: _import('form-conf/form-conf-list'), name: "表单配置", icon: 'icon-liebiao', meta: { role: ['FormConfList'] }, },
        { path: "form-conf", component: _import('form-conf/form-conf'), name: "添加表单", hidden: true, meta: { role: ['AddFormConf'] } },
        { path: "edit-form-conf/:Id", component: _import('form-conf/form-conf'), name: "编辑表单", hidden: true, meta: { role: ['EditFormConf'] } },
        { path: "dimension-list", component: _import('form-conf/dimension-list'), name: "维度列表", icon: 'icon-liebiao', meta: { role: ['DimensionList'] }, },
        { path: "AddDimension", component: _import('form-conf/AddDimension'), name: "添加维度", hidden: true, meta: { role: ['AddDimension'] } },
        { path: "EditDimension/:Id(\\d+)", component: _import('form-conf/AddDimension'), name: "编辑维度", hidden: true, meta: { role: ['EditDimension'] } },
        { path: "AssessmentList", component: _import('form-conf/AssessmentList'), name: "测评结果", icon: 'icon-liebiao', meta: { role: ['AssessmentList'] } },
        { path: "AssessmentDetail/:Id(\\d+)", component: _import('form-conf/AssessmentDetail'), name: "测评详情", hidden: true, meta: { role: ['AssessmentDetail'] } },
        { path: "DemandList", component: _import('form-conf/DemandList'), name: "补充资料/需求对接", icon: 'icon-liebiao', meta: { role: ['DemandList'] } },
        { path: "StandardScoresList", component: _import('form-conf/StandardScoresList'), name: "总体得分", icon: 'icon-liebiao', meta: { role: ['StandardScoresList'] } },
        { path: "StandardScores/:Id(\\d+)", component: _import('form-conf/StandardScores'), name: "得分编辑", hidden: true, meta: { role: ['StandardScores'] } },
      ]
    },
    //系统设置
    {
        path: "/Setting",
        name: "系统设置",
        component: Layout,
        redirect: '/Setting/CommonRule',
        icon: 'icon-jifenguize',
        children: [
        ]
    }
]



// WEBPACK FOOTER //
// ./src/router/index.js